module.exports = __webpack_public_path__ + "img/reaction8.6712f04c.png";